import z from "zod";

export const keywordSchema = z.object({
  name: z.string().trim().optional(),
  value: z
    .string()
    .trim()
    .optional()
    .refine(
      (val) =>
        !val ||
        /^\/[^\s]*$/.test(val) ||
        z.string().url().safeParse(val).success,
      { message: "URL is invalid. Must start with / or be a valid URL." }
    ),
});

export const formKeywordsSchema = z.object({
  keywords: z.array(keywordSchema),
});
export type FormKeywords = z.infer<typeof formKeywordsSchema>;